<template>
  <div class="news-list">
    <BasePage mode="list">
      <div slot="toolBar">
        <el-row>
          <div style="float: left">
            <el-button
              v-access:add
              icon="el-icon-plus"
              @click="add"
              size="small"
              :disabled="isloading"
              >新增
            </el-button>
          </div>
          <div style="float: right">
            <OfSearch
              @search="search"
              style="float: left; padding-right: 5%"
              :placeholder="placeholder"
            ></OfSearch>
            <el-button type="danger" @click="loadData">查询</el-button>
          </div>
        </el-row>
      </div>

      <div>
        <el-table
          border
          hightlight-current-row
          style="width: 100%"
          :header-cell-class-name="headerRow"
          :data="listData"
          :max-height="tableMaxHeight()"
          v-loading="isloading"
        >
        <el-table-column
            prop="Id"
            label="项目支出编号"
            width="200"
          ></el-table-column>
          <el-table-column
            prop="CapitalId"
            label="资金支出明细编号"
            width="200"
          ></el-table-column>
          <el-table-column
            prop="Title"
            label="标题"
            width="250"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            prop="Describe"
            label="支出描述"
            
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            prop="Amount"
            label="支出金额"
            align="right"
            width="100"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            prop="ExpendTime"
            label="支出时间"
            align="center"
            width="140"
          >
            <template slot-scope="scope">
              {{ (scope.row.ExpendTime * 1000) | formatDate }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="100" align="center">
            <template slot-scope="scope">
              <el-button
                v-access:read
                @click="query(scope.row)"
                type="text"
                size="mini"
                >详情
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination-wapper">
        <OfPagination
          :total="total"
          :pageSize="pageSize"
          :currentPage="currentPage"
          @onSizeChange="handleSizeChange"
          @onCurrentChange="handleCurrentChange"
        ></OfPagination>
        <ModelQuery
          v-if="showQuery"
          :dataForm="formData"
          @formCallBack="formCallBack"
        >
        </ModelQuery>
        <ModelEdit
          v-if="showEdit"
          :ImplementId="ImplementId"
          @formCallBack="formCallBack"
        >
        </ModelEdit>
      </div>
    </BasePage>
  </div>
</template>
<script>
import BasePage from "@/components/base/of_page/of_page";
import OfSearch from "@/components/controls/of_search/of_search";
import OfPagination from "@/components/controls/of_pagination/of_pagination";
import ModelQuery from "@/modules/zjrc/pages/material/implementproject/addprojectexpend/query";
import ModelEdit from "@/modules/zjrc/pages/material/implementproject/addprojectexpend/edit";
import api from "@/modules/zjrc/api";

export default {
  name: "list",
  props: {
    ImplementId: {
      type: String,
      default: ''
    }
  },
  components: {
    BasePage,
    OfSearch,
    OfPagination,
    ModelQuery,
    ModelEdit,
  },
  data() {
    return {
      headerRow: "headerRow",
      listData: [], //列表数据
      isloading: false,
      total: 0, //列表行数
      currentPage: 1, //页码
      pageSize: 15, //每页行数
      placeholder: "请输入标题",
      // ImplementId: "", //项目Id
      showQuery: false,
      showEdit: false,
      formData: {}, //详情对象
      searchKey:"",//关键字搜索
    };
  },
  mounted() {
    let that = this;
    // that.ImplementId = that.$route.query.Id;
    that.loadData();
  },
  methods: {
    //初始化数据
    loadData() {
      let that = this;
      that.isloading = true;
      let params = {
        PageIndex: that.currentPage,
        PageSize: that.pageSize,
        Id: that.ImplementId,
        searchKey:that.searchKey
      };
      api.QueryImplementExpendById(params).then((res) => {
        if (res.data.Code == 0) {
          that.total = res.data.Data.total;
          that.listData = res.data.Data.rows;
          that.isloading = false;
        }
      });
    },
    //新增
    add() {
      let that = this;
      that.showEdit = true;
    },
    //详情
    query(rowData) {
      let that = this;
      that.formData = rowData;
      that.showQuery = true;
    },
    //回调
    formCallBack(data) {
      let that = this;
      that.showQuery = false;
      that.showEdit = false;
      if (data) {
        that.loadData();
      }
    },
    //关键字搜索
    search(searchKey) {
      let that=this;
      that.searchKey=searchKey;
      this.loadData()
    },
    //改变分页大小
    handleSizeChange(val) {
      let that = this;
      that.currentPage = 1;
      that.pageSize = val;
      that.loadData();
    },
    //改变当前页码
    handleCurrentChange(val) {
      if (that.total > that.pageSize) {
        that.currentPage = val;
        that.loadData();
      }
    },
    //列表高度
    tableMaxHeight() {
      var clientHeight = window.innerHeight;
      var tableMaxHeight = 0;
      if (clientHeight && clientHeight !== undefined) {
        tableMaxHeight = clientHeight - 280;
      }
      return tableMaxHeight;
    },
  },
};
</script>
